// Funciones
import { ROUTES } from '../../../../../const/routes';

/**
 * Assets de los displays
 * @param {*} scene
 */
export function cargaAssetsDisplays(scene) {
  /*/=======================================================================================\*\
  ||                               DISPLAYS APUESTA                                          ||
  \*\=======================================================================================/*/
  scene.load.image(
    'displayApuesta',
    ROUTES.rutaBlackJackDisplays + '/displayApuesta1Resized.png'
  );
  scene.load.image(
    'displayApuestaGana',
    ROUTES.rutaBlackJackDisplays + '/displayApuesta2GanaResized.png'
  );
  scene.load.image(
    'displayApuestaPierde',
    ROUTES.rutaBlackJackDisplays + '/displayApuesta3PierdeResized.png'
  );

  /*/=======================================================================================\*\
  ||                             DISPLAYS VALOR CARTAS                                       ||
  \*\=======================================================================================/*/
  scene.load.image(
    'displayValorCartas',
    ROUTES.rutaBlackJackDisplays + '/displayValorCartas1Resized.png'
  );
  scene.load.image(
    'displayValorCartasValido',
    ROUTES.rutaBlackJackDisplays + '/displayValorCartas2ValidoResized.png'
  );
  scene.load.image(
    'displayValorCartasExacto21',
    ROUTES.rutaBlackJackDisplays + '/displayValorCartas3Exacto21Resized.png'
  );
  scene.load.image(
    'displayValorCartasExcede21',
    ROUTES.rutaBlackJackDisplays + '/displayValorCartas4Excede21Resized.png'
  );

  /*/=======================================================================================\*\
  ||                               DISPLAYS PREMIO                                           ||
  \*\=======================================================================================/*/
  scene.load.image(
    'displayPremio',
    ROUTES.rutaBlackJackDisplays + '/displayPremioResized.png'
  );
}
